import type { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import { usePortal } from 'utils/hooks';

interface Props {
    id: string;
}

export const Portal = ({ id, children }: PropsWithChildren<Props>) => {
    const target = usePortal(id);
    return createPortal(children, target);
};
